exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sidebar[data-v-34d83165],\n.overlay[data-v-34d83165] {\n  transition: all 0.3s ease-in-out;\n}\n.sidebar-enter[data-v-34d83165],\n.sidebar-leave-to[data-v-34d83165] {\n  opacity: 0;\n}\n.sidebar-enter .sidebar[data-v-34d83165],\n.sidebar-leave-to .sidebar[data-v-34d83165] {\n  transform: translateX(-100px);\n}\n", ""]);

// exports
